import { combineReducers } from "redux";
import { config } from "./configReducer";
import { home } from "./homeReducer";
import { page } from "./pageReducer";

const appReducers = combineReducers({
  config,
  home,
  page
});

const rootreducer = (state, action) => {
  return appReducers(state, action);
};

export default rootreducer;
